<template>
    <div>
        <Grid :data-items="result"
              :columns="columns"
              :filterable="false"
              :pageable="true"
              :skip="skip"
              :take="take"
              :total="total"
              :selected-field="selectedField"
              @pagechange="pageChange"
              @edit="edit"
              @remove="remove"
              @copy="copy"
              @check="check">
            <grid-toolbar>
                <v-btn color="primary right" dark @click="insert">Añadir registro</v-btn>
            </grid-toolbar>
            <grid-norecords>
                There is no data available custom
            </grid-norecords>
        </Grid>

        <v-dialog v-model="dialog"
                  max-width="400">
            <v-card>
                <v-card-title class="headline">Confirma la eliminación</v-card-title>

                <v-card-text>
                    ¿Está seguro que desea eliminar el enlace?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color=""
                           text
                           @click="dialog = false">
                        Cancelar
                    </v-btn>

                    <v-btn color="blue"
                           text
                           @click="confirmDelete">
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCheck"
                  max-width="800">
            <v-card>
                <v-card-title class="headline">¿El enlace ha cargado correctamente? {{getUrl()}}</v-card-title>

                <v-card-text>
                    <iframe v-if="!urlActualConError" style="width:100%" :src="getUrl()" @onerror="errorCargaIframe()"></iframe>
                    <div v-else> La página no se puede cargar en un iframe, pruebe a abrirla en una nueva pestaña</div>
                </v-card-text>

                <v-card-actions>
                    <v-btn color=""
                           text
                           @click="abrirEnNuevaVentana(itemCheck)">
                        Probar en nueva pestaña
                    </v-btn>
                    <v-spacer></v-spacer>

                    <v-btn color=""
                           text
                           @click="linkDown(itemCheck)">
                        Enlace caido
                    </v-btn>

                    <v-btn color="blue"
                           text
                           @click="linkUp(itemCheck)">
                        Enlace correcto
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <input id="hddCopyInfo" type="hidden" />
    </div>




</template>

<script>
    import { GridToolbar, GridNoRecords } from '@progress/kendo-vue-grid';
    import { mapState } from 'vuex';
    import HTTP from '../http-common';
    import { eventHub } from '../http-common/eventhub';

    const CommandCell = {
        props: {
            field: String,
            dataItem: Object,
            format: String,
            className: String,
            columnIndex: Number,
            columnsCount: Number,
            rowType: String,
            level: Number,
            expanded: Boolean,
            editor: String
        },
        template: ` <td>
                    <button
                        class="k-button k-grid-edit-command"
                        @click="editHandler">
                        Editar
                    </button>
                    <button
                        class="k-button k-grid-remove-command"
                        @click="removeHandler">
                        Eliminar
                    </button>
                    <br />
                    <button
                        class="k-button k-grid-custom mt-1"
                        @click="copyHandler">
                        Copiar
                    </button>
                    <br />
                    <button v-if="dataItem.estado === 'Sin respuesta'"
                        class="k-button k-grid-custom mt-1"
                        @click="checkHandler">
                        Probar Url
                    </button>
                </td>`,
        methods: {
            copyHandler: function () {
                this.$emit('copy', { dataItem: this.dataItem });
            },
            editHandler: function () {
                this.$emit('edit', { dataItem: this.dataItem });
            },
            removeHandler: function () {
                this.$emit('remove', { dataItem: this.dataItem });
            },
            checkHandler: function () {
                this.$emit('check', { dataItem: this.dataItem });
            }
        }
    };

    export default {
        name: 'Listado',
        props: [],
        components: {
            'grid-toolbar': GridToolbar,
            'grid-norecords': GridNoRecords
        },
        data() {
            return {
                selectedField: 'selected',
                selectedID: 1,
                columns: [
                    { field: 'estado', title: 'Estado', width: '80px', cell: this.cellEstadoFunction },
                    { field: 'idLink', title: 'Id', width: '80px' },
                    { field: 'descripcion', title: 'Descripción' },
                    { field: 'palabraClave', title: 'Palabra Clave Única' },
                    { field: 'url', title: 'Dirección', cell: this.cellUrl },
                    { field: 'titulo', title: 'Título libro' },
                    { field: 'creador', title: 'Autor' },
                    { field: 'tipo', title: 'Tipo' },
                    { field: 'numVisitas', title: 'Visitas', width: '80px' },
                    { cell: CommandCell, width: '180px' }
                ],
                skip: 0,
                take: 10,
                dialog: false,
                dialogCheck: false,
                itemBorrar: null,
                itemCheck: null,
                urlActualConError: false,
            }
        },
        computed: {
            ...mapState(['dataItems', 'filtroInicial', 'tipos']),
            result() {
                return this.dataItems.slice(this.skip, this.take + this.skip)
            },
            total() {
                return this.dataItems.length
            },
            selectedItem() {
                return this.dataItems.find((item) => item.idLink === this.selectedID);
            }
        },
        methods: {
            pageChange(event) {
                this.skip = event.page.skip;
                this.take = event.page.take;

            },
            cellEstadoFunction: function (h, tdElement, props, clickHandler) {
                var imagen = "";
                if (props.dataItem.estado === "Activo") {
                    imagen = "enabled.png";
                } else if (props.dataItem.estado === "Sin respuesta") {
                    imagen = "question.png";
                } else {
                    imagen = "disabled.png";
                }

                return h('td', [
                    h('img', {
                        attrs: {
                            src: require("@/assets/" + imagen),
                            alt: props.dataItem.estado,
                            title: props.dataItem.estado + " (HTTP Status - " + (props.dataItem.httpStatusCode == null ?
                                    "Sin estado" : props.dataItem.httpStatusCode) + ")"
                        }
                    })
                ]);
            },
            cellUrl: function (h, tdElement, props, clickHandler) {
                return h('td', [
                    h('a', {
                        attrs: {
                            href: props.dataItem.url,
                            target: "_blank",
                            rel: "noopener noreferrer"
                        }
                    }, props.dataItem.url)
                ]);
            },

            insert(event) {
                this.$router.push({
                    name: 'nuevo', params: {
                        "dataItem": {
                            idLink: 0,
                            titulo: "",
                            creador: "",
                            descripcion: "",
                            palabraClave: "",
                            url: "",
                            numVisitas: 0,
                            estado: "",
                            idEstado: null,
                            idTipo: this.filtroInicial.idTipo,
                            tipo: "",
                            idEditorial: this.filtroInicial.idEditorial,
                            fechalink: "",
                            editorial: ""
                        }
                    }
                })
            },
            remove(event) {
                this.dialog = true;
                this.itemBorrar = event.dataItem;

            },
            confirmDelete() {
                this.dialog = false;
                HTTP.delete('Enlace', {
                    data: this.itemBorrar
                }
                )
                    .then(() => {
                        this.$snotify.success("Registro eliminado correctamente", {
                            position: "rightTop"
                        });          
                        
                        this.$store.dispatch('establecerEnlaces');
                    })
                    .catch(e => {
                        eventHub.$emit('error', e)
                    });
            },
            edit(event) {
               
                this.$router.push({ name: 'editar', params: { "dataItem": event.dataItem } })
            },
            copy(event) {
                let tipo = this.$_.findWhere(this.tipos, { idEditorial: event.dataItem.idEditorial });
                var urlBase = tipo.url2 == null || tipo.url2 == '' ?
                    tipo.url == null || tipo.url == '' ? '' : tipo.url : tipo.url2;

                if (urlBase != '') {
                    var url = "https://" + urlBase + "/" + event.dataItem.palabraClave;
                    this.setCopyInfo(url);
                }                               
            },
            check(event) {
                //alert('probando: ' + event.dataItem.url);
                this.itemCheck = event;
                this.urlActualConError = false;
                // Probando:
                HTTP.get(this.itemCheck.dataItem.url).then((response) => {
                    console.log(response.headers);

                    this.urlActualConError = false;
                    })
                    .catch(e => {
                        //eventHub.$emit('error', e)
                        this.urlActualConError = true;
                    });

                this.dialogCheck = true;
            },
            linkUp(data) {
                this.dialogCheck = false;
                //TODO: Constantes
                this.linkModificarEstado(this.itemCheck.dataItem.idLink, 1);
            },
            linkDown(data) {
                this.dialogCheck = false;
                this.linkModificarEstado(this.itemCheck.dataItem.idLink, 2);
            },
            linkModificarEstado(idLink, idEstado) {
                HTTP.patch('Enlace', {idLink:idLink,idEstado:idEstado})
                    .then(() => {
                        //this.$store.dispatch('refrescaEditoriales');
                        this.$store.dispatch('establecerEnlaces');
                        this.$snotify.success("Registro modificado correctamente", {
                            position: "rightTop"
                        });
                    })
                    .catch(e => {
                        eventHub.$emit('error', e)
                    });
            },
            getUrl() {
                if (this.itemCheck && this.itemCheck.dataItem)
                    return this.itemCheck.dataItem.url;
                else
                    return '';
            },
            errorCargaIframe() {
                alert("Error en la carga del ifrema use el bóton, pruebe a abrir la URL en otra ventana");
            },
            abrirEnNuevaVentana() {
                window.open(this.itemCheck.dataItem.url,"_blank");
            },
            setCopyInfo(value) {
                let hddCopyInfo = this.$el.querySelector('#hddCopyInfo');
                hddCopyInfo.setAttribute('type', 'text');
                hddCopyInfo.value = value;
                hddCopyInfo.select();

                try {
                    navigator.clipboard.writeText(value).then(function () {
                        alert('Copia realizada correctamente');
                    }, function () {
                        alert('Error en la copia');
                    });

                    //var successful = document.execCommand('copy');
                    //var msg = successful ? 'Copia realizada correctamente' : 'Error en la copia';
                    //alert(msg);
                }
                catch (err) {
                    alert('Oops!, no se ha podido realizar la copia');
                }

                hddCopyInfo.setAttribute('type', 'hidden');
                window.getSelection().removeAllRanges();
            }
        }
    }
</script>

<style>
    .k-pager-numbers .k-link.k-state-selected,
    .k-pager-numbers .k-link.k-state-selected:hover {
        background-color: #4aaee2 !important;
        color: #fff !important;
    }

    .k-pager-numbers .k-link,
    .k-pager-numbers .k-link:hover {
        color: #4aaee2 !important;
    }

        .k-pager-numbers .k-link:focus {
            box-shadow: none !important;
        }

    .k-grid {
        height: auto !important;
    }

        .k-grid th, .k-grid td {
            padding: 4px 8px !important;
        }

    .k-master-row td img {
        margin: 0 auto;
        display: block;
    }

    .v-dialog {
        text-align: left;
    }

    .v-dialog .v-card__actions {
        border-top: 1px solid #dfdfdf;
    }

    .v-dialog .v-card__title {
        font-weight: 300 !important;
        color: #2196F3;
    }
</style>